// We have to represent the regex as a string for it to work properly with Bootstrap validation in templates.
export const PHONE_NUMBER_PATTERN = '\\(\\d{3}\\) \\d{3}-\\d{4}';
export const PASSWORD_PATTERN = '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$';
export const BIOMETRIC_HEIGHT = '^[0-9]{1}[\'][0-9]{1,2}["]$';
export const BIOMETRIC_WEIGHT = '^((?!(0))[0-9]{1,3})$';
export const BIOMETRIC_BP = '^[0-9]{2,3}[/][0-9]{2,3}$';
export const BIOMETRIC_HBA1C = '^[0-9]{1,2}[\\.][0-9]{1,2}$';
export const BIOMETRIC_TRIGLYCERIDES = '^((?!(0))[0-9]{1,3})$';
export const BIOMETRIC_TCHOL = '^((?!(0))[0-9]{1,3})$';
export const BIOMETRIC_HDL = '^((?!(0))[0-9]{1,3})$';
export const BIOMETRIC_LDL = '^((?!(0))[0-9]{1,3})$';
export const BIOMETRIC_TEMPERATURE = '^[0-9]{1,3}\\.([0-9]{1,2})$';
export const BIOMETRIC_GLUCOSE = '^((?!(0))[0-9]{1,3})$';
export const TARGET_LIST_NAME_PATTERN = '[-_ A-Za-z0-9]+';
export const DOMAIN_PATTERN =
  '^(\\s*@([\\-a-zA-Z0-9]+\\.)+[a-zA-Z]{2,}\\s*)(,\\s*@([\\-a-zA-Z0-9]+\\.)+[a-zA-Z]{2,}\\s*)*$';

/**
 * Constructs a RegExp string with all uppercase/lowercase combinations for the given
 * file extensions array.
 *
 * @param extensions file extensions
 */
export function getFileExtensionPattern(extensions: string[]): string {
  return (
    '^.*(' +
    extensions
      .map(getCasePermutations)
      .reduce((previousValue, currentValue) => previousValue.concat(currentValue), [])
      .map((fileExtension) => '\\.' + fileExtension)
      .join('|') +
    ')$'
  );
}

/**
 * Gets all permutations of uppercase and lowercase letters
 * Copied from https://stackoverflow.com/questions/27992204/find-all-lowercase-and-uppercase-combinations-of-a-string-in-javascript
 *
 * @param str string to get all uppercase/lowercase permutations of
 */
function getCasePermutations(str: string): string[] {
  const permutations = new Set<string>();
  const letters = str.split('');
  const permutationCount = Math.pow(letters.length, 2);

  for (let i = 0; i < permutationCount; i++) {
    for (let k = 0, j = i; k < letters.length; k++, j >>= 1) {
      letters[k] = j & 1 ? letters[k].toUpperCase() : letters[k].toLowerCase();
    }

    permutations.add(letters.join(''));
  }

  return Array.from(permutations);
}
